
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  apiOrderImportLists,
  apiShopOrderDetail,
  apiShopOrderLog,
} from "@/api/order";
import { apiShopLists } from "@/api/shop";
import { RequestPaging, formatTimestamp } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import OrderImagePreview from "@/components/order-image-preview.vue";
import ExportData from "@/components/export-data/index.vue";
import SearchBtns from "@/components/search-btns.vue";

@Component({
  components: {
    LsPagination,
    DatePicker,
    OrderImagePreview,
    ExportData,
    SearchBtns,
  },
})
export default class ImportOrderList extends Vue {
  // 界面表格数据
  pager: any = new RequestPaging();
  formatTimestamp = formatTimestamp;
  apiOrderImportLists = apiOrderImportLists;
  searchObj = {
    shop_id: "",
    start_time: "",
    end_time: "",
    type: "",
  };
  loading = false;
  shop_lists = [];
  checkdArr: any = [];
  checkAll = false;
  orderIdArr: any = [];
  time: any = [];
  sourceIcon: any = [
    {
      key: "",
      value: "全部",
    },
    {
      key: 1,
      value: "亚马逊",
    },
    {
      key: 2,
      value: "内部系统",
      url: "/template/订单导入模板.xlsx",
    },
    {
      key: 3,
      value: "LAZADA",
    },
    {
      key: 4,
      value: "TIKTOK",
    },
    {
      key: 17,
      value: "沃尔玛",
    },
    {
      key: 5,
      value: "淘宝",
    },
    {
      key: 6,
      value: "抖音",
    },
    {
      key: 7,
      value: "快手",
    },
    {
      key: 8,
      value: "拼多多",
    },
    {
      key: 9,
      value: "京东",
    },
    {
      key: 10,
      value: "WMS",
    },
    {
      key: 11,
      value: "马帮",
      url: "/template/mabang.xlsx",
    },
    {
      key: 12,
      value: "TEMU自研",
    },
    {
      key: 14,
      value: "Shopee",
    },
    {
      key: 20,
      value: "SHEIN自运营",
    },
    {
      key: 21,
      value: "SHEIN半托",
    },
    {
      key: 22,
      value: "SHEIN全托",
    },
    {
      key: 23,
      value: "SHEIN自营",
    },
    {
      key: 15,
      value: "TEMU全托导入订单",
    },
    {
      key: 97,
      value: "TEMU CN",
    },
    {
      key: 98,
      value: "TEMU半托发品",
    },
    {
      key: 99,
      value: "TEMU全托发品",
    },
    {
      key: 100,
      value: "TEMU本本",
    },
    {
      key: 24,
      value: "速卖通",
    },
    {
      key: 25,
      value: "Shopify",
    },
    {
      key: 101,
      value: "TIKTOK本本",
    },
    {
      key: 102,
      value: "OZON",
    },
  ];
  payStatusList = [
    {
      key: "",
      value: "全部",
    },
    {
      key: 1,
      value: "已支付",
    },
    {
      key: 0,
      value: "未支付",
    },
  ];
  selectionArr: any = [];
  // 日期选择器配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  handleSearch() {
    this.loading = true;
    this.getOrderList();
  }
  getYesterdayDate(type = 1) {
    let date = new Date();
    if (type == 1) {
      date.setDate(date.getDate() - 1);
    }
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}-${month}-${day}`;
  }
  changeDate() {
    if (!this.time) {
      this.searchObj.start_time = "";
      this.searchObj.end_time = "";
    } else {
      this.searchObj.start_time = this.time[0];
      this.searchObj.end_time = this.time[1];
    }
    this.getOrderList();
  }
  handleCheckedOrdersChange(value: any[]) {
    this.checkdArr = value;
    if (value.length) {
      value.forEach((v) => {
        this.pager.lists.forEach((item: any) => {
          if (v === item.order_import_id) {
            this.orderIdArr.push(item.id);
          }
        });
      });
    } else {
      this.orderIdArr = [];
    }
  }
  //全选订单
  handleCheckChildAllChange(val: boolean) {
    this.checkdArr = val
      ? this.pager.lists.map((item: any) => item.order_import_id)
      : [];
    this.orderIdArr = val ? this.pager.lists.map((item: any) => item.id) : [];
  }
  getShopList() {
    apiShopLists({ page_size: 9999 }).then((res) => {
      this.shop_lists = res.lists;
    });
  }

  getSourceIcon(type: string) {
    return this.sourceIcon.find((item: any) => item.key === type);
  }
  getOrderList() {
    this.loading = true; // 开始加载状态
    this.pager
      .request({
        callback: this.apiOrderImportLists,
        params: {
          ...this.searchObj,
        }, // 传递搜索参数
      })
      .then((res: any) => {
        this.loading = false; // 请求完成，停止加载状态
      })
      .catch((error: any) => {
        console.error("获取订单列表失败:", error);
      });
  }

  handleSelectionChange(selectedItems: any[]) {
    this.selectionArr = selectedItems; // 更新选中项数组
  }

  getRowKeys(item: any) {
    return item.id;
  }

  getSpecValue(input: any) {
    return this.processInput(input);
  }

  getLogistics(logistics: any) {
    // return this.setLogistics(logistics);
  }

  getProductionCode(row: any) {
    return row.model_id + this.processInput(row.spec_value_str);
  }

  getMainImage(row: any, size: 150) {
    if (row.image) {
      if (typeof row.image === "string") {
        return `${row.image}?x-oss-process=image/resize,w_${size},h_${size}`;
      } else if (typeof row.image === "object") {
        return `${row.image[0]}?x-oss-process=image/resize,w_${size},h_${size}`;
      }
    }
  }

  getOrderInfo(row: any) {
    const infoList = [];
    if (row.otherdata?.source_name) {
      infoList.push({
        key: "source_name",
        class: "marr-8 primary-color",
        text: row.otherdata.source_name,
      });
    }
    if (row.order_sn) {
      infoList.push({
        key: "order_sn",
        class: "marr-8",
        text: "订单号: " + row.order_sn,
      });
    }
    if (row.out_id) {
      infoList.push({
        key: "out_id",
        class: "marr-8",
        text: "外部订单号: " + row.out_id,
      });
    }
    if (row.plan_code) {
      infoList.push({
        key: "plan_code",
        class: "marr-8",
        text: "生产计划:" + "【" + row.plan_code + "】" + row.plan_name,
      });
    }
    if (row.order_sn_s) {
      infoList.push({
        key: "order_sn_s",
        class: "marr-8",
        text: "子订单号:" + row.order_sn_s,
      });
    }
    if (row.return_order === 1) {
      infoList.push({
        key: "remark",
        class: "return-remark",
        text: row.remark,
      });
    }
    return infoList;
  }

  getOrderTypeText(type: number) {
    switch (type) {
      case 1:
        return "一项一件";
      case 2:
        return "一项多件";
      case 3:
        return "多项多件";
      default:
        return "";
    }
  }

  processInput(input: any) {
    if (!input) return "";
    if (input.includes("},")) {
      try {
        const parseItem = JSON.parse(`[${input}]`);
        const zhCnArr = parseItem.map((v: any) => v.zh_cn);
        return zhCnArr.join(",");
      } catch (e) {
        return input;
      }
    } else if (input.includes("{") && input.includes("}")) {
      try {
        const parseItem = JSON.parse(input);
        return parseItem.zh_cn || parseItem;
      } catch (e) {
        return input;
      }
    } else {
      return input;
    }
  }

  timestampToYYMMDDHHMMSS(timestamp: number) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  checkTimeStatus(inputTime: string | number): string {
    const now = new Date();
    const targetTime = new Date(inputTime);

    if (isNaN(targetTime.getTime())) {
      console.error(
        "Invalid time format, please use YYYY-MM-DD hh:mm:ss or timestamp",
      );
      return "blue"; // 返回默认值
    }

    const diffInMs = targetTime.getTime() - now.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if (diffInMs < 0) {
      return "red"; // 已过期
    } else if (diffInHours <= 3) {
      return "#ffd704"; // 三小时内 // 橘色
    } else {
      return "blue"; // 其他情况
    }
  }
  mounted() {
    this.pager.size = 20;
    this.getShopList();
    let start_time = new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    let end_time = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    this.searchObj.start_time = start_time;
    this.searchObj.end_time = end_time;
    this.time = [start_time, end_time];
    this.getOrderList();
  }
}
